// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from "element-ui";
import locale from 'element-ui/lib/locale'
import "element-ui/lib/theme-chalk/index.css";
import VueI18n from 'vue-i18n'
import zh from './i18n/lang_zh.js'
import en from './i18n/lang_en.js'
import './assets/css/list.base.css';
import VueLazyload from 'vue-lazyload'  //引入这个懒加载插件
import 'swiper/dist/css/swiper.css';
import './assets/iconfont/iconfont.css'
import VueClipboard from 'vue-clipboard2';
import echarts from 'echarts';



Vue.prototype.$echarts = echarts;

Vue.use(VueClipboard);
Vue.use(ElementUI);
Vue.config.productionTip = false;
Vue.use(VueI18n);
Vue.prototype.HOSTAPI = '/api';
Vue.prototype.WEBHOSTAPI = '';

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: require('./assets/img/image-error.png'),
  attempt: 1
});

const i18n = new VueI18n({
  // // 语言标识，后面会用做切换和将用户习惯存储到本地浏览器
   locale: window.localStorage.getItem('nike-lang') || 'zh',
   //locale: 'zh', // 语言标识
  messages: {
    'zh': zh,
    'en': en
  },
  silentTranslationWarn: true
});
locale.i18n((key, value) => i18n.t(key, value)) //elementui多语言切换

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>',
  i18n
});



// WEBPACK FOOTER //
// ./src/main.js